import React, { useState, useRef, useEffect } from 'react';
import { useStyles } from './TakisGridItem.styles';
import TakisButton from './TakisButton';
import PropTypes from 'prop-types';
import useOnScreen from '../hooks/useOnScreen';
import { SpriteAnimator } from 'react-sprite-animator'
import { useLanguage } from '../hooks/useLanguage';
import { useHistory } from 'react-router-dom'
import TakisSpan from './TakisSpan';
import { resolveAlias } from '../utils/uriHelper';

export default function TakisGridItem({
  frontImageSrc,
  frontImageAlt,
  backLayerSrc,
  backLayerAlt,
  middleLayerSrc,
  middleLayerAlt,
  cta,
  description,
  isWide,
  itemIndex,
  onMobile,
  disableLinks
}) {
  const [cardHover, setCardHover] = useState(false);
  const [resolvedHref, setResolvedHref] = useState(cta.href || '');
  const classes = useStyles();
  const ref = useRef()
  const isVisible = useOnScreen(ref)
  const history = useHistory()
  const language = useLanguage();
  const hasLink = disableLinks ? false : (resolvedHref || '').trim().length > 0;
  TakisGridItem.propTypes = {
    frontImageSrc: PropTypes.string.isRequired,
    frontImageAlt: PropTypes.string.isRequired,
    backLayerSrc: PropTypes.string.isRequired,
    backLayerAlt: PropTypes.string.isRequired,
    middleLayerSrc: PropTypes.string.isRequired,
    middleLayerAlt: PropTypes.string.isRequired,
    isWide: PropTypes.bool,
    cta: PropTypes.object,
    itemIndex: PropTypes.number,
    onMobile: PropTypes.bool,
    disableLinks: PropTypes.bool,
  };

  useEffect(() => {
    window.addEventListener('pageshow', (event) => {
      // fix for safari cached page
      if (event.persisted) {
        setCardHover(false)
      }
    });
  }, [])

  useEffect(() => {
    let mounted = true;
    (async () => {
      const target = await resolveAlias(cta.href, language);
      if (mounted) setResolvedHref(target);
    })();
    return () => { mounted = false };
  }, [cta?.href, language]);

  const onCardClick = async () => {
    if (!hasLink) return;
    history.push(resolvedHref);
  }
  const mobileHover = isVisible && onMobile;
  const imageHoverClass = itemIndex % 2 !== 0 ? classes.frontImageHoverRight : classes.frontImageHoverLeft;

  return (
    <div ref={ref}
      className={`${classes.takisGridItem}
      ${hasLink ? classes.cursorPointer : ""}`}
    >
      <div
        className={`${classes.imageContainer}
        ${isWide ? classes.imageContainerWide : ""}`}

        {...(hasLink && {
          onClick: onCardClick,
          onMouseEnter: () => setCardHover(true),
          onMouseLeave: () => setCardHover(false)
        })}
      >
        {!isWide && <>
          {/* Fire */}
          <SpriteAnimator
            className={classes.backgroundSprite}
            sprite={backLayerSrc}
            width={380}
            height={380}
            fps={12}
            frame={cardHover ? 0 : 1}
            stopLastFrame={true}
            shouldAnimate={cardHover}
          />
          {/* Fruits middle layer */}
          <img
            className={`${classes.backgroundImage}
            ${cardHover || mobileHover ? classes.backgroundImageHover : ""}`}
            src={middleLayerSrc}
            alt={middleLayerAlt}
            loading="lazy"
          />
        </>}
        <img
          className={`${isWide ? classes.frontImageWide : classes.frontImage}
          ${(cardHover && !isWide) || (mobileHover && !isWide) ? imageHoverClass : ""}`}
          src={frontImageSrc}
          alt={frontImageAlt}
          loading="lazy"
        />
      </div>
      <div
        dangerouslySetInnerHTML={{ __html: description }}
        className={`${classes.description}`}>
      </div>
      <div
        className={`${classes.ctaContainer}`}
        {...(hasLink && {
          onClick: onCardClick,
          onMouseEnter: () => setCardHover(true),
          onMouseLeave: () => setCardHover(false),
          onFocus: () => setCardHover(true),
          onBlur: () => setCardHover(false)
        })}
      >
        {(hasLink
          ? <TakisButton
            modifier={`${classes.cta}`}
            isActive={cardHover}
            title={cta.title}
            href={resolvedHref}
            color={cta.color}
            orientation={cta.orientation}
          />
          : <TakisSpan
            modifier={`${classes.cta}`}
            title={cta.title}
            color={cta.color}
            orientation={cta.orientation}
          />)}

      </div>
    </div>
  );
}
